<script setup lang="ts">
import { useAppStore } from '~/stores/AppStore'
import { AppTheme } from '~/types'
import { NuxtLink } from '#components'
import type { RouteLocationNormalized } from 'vue-router'

interface WorkPageFilterItemProps {
  isActive?: boolean
  isDisabled?: boolean
  to?: RouteLocationNormalized | string | undefined
  invertColors?: boolean
}

withDefaults(defineProps<WorkPageFilterItemProps>(), {
  isActive: false,
  isDisabled: false,
  to: undefined,
  invertColors: false
})

defineEmits(['click'])

const store = useAppStore()
</script>

<template>
  <component
    :is="to ? NuxtLink : 'button'"
    :to="to"
    :type="to ? undefined : 'button'"
    class="relative flex h-9 flex-shrink-0 items-center overflow-hidden whitespace-nowrap rounded-full text-sm font-medium lg:h-12 lg:text-lg"
    :class="[
      {
        'pointer-events-none': isDisabled
      }
    ]"
    @click="$emit('click')"
  >
    <span
      :class="[
        isActive ? 'scale-1 ease-quart-out' : 'scale-0 ease-quart-in',
        {
          'bg-white text-black':
            store.theme === AppTheme.DARK || (store.theme === AppTheme.LIGHT && invertColors),
          'bg-black text-white':
            store.theme === AppTheme.LIGHT || (store.theme === AppTheme.DARK && invertColors)
        }
      ]"
      class="absolute left-0 top-0 inline-block h-full w-full transform-gpu rounded-full transition-transform duration-400 will-change-transform"
    />
    <span class="relative transform-gpu px-6 text-black mix-blend-difference invert"><slot /></span>
  </component>
</template>
